module.exports = __webpack_public_path__ + "img/Logo_La_Dépêche_du_Midi.65d4453c.png";